import userService from '@/services/user';

/**
 * @returns {Object} initialize state
 */
const initialState = () => {
  return {
    records: null,
  };
};
const state = initialState();
const getters = {
  getIsDone: (state) => (type) => {
    const record = state.records?.[type];
    return record === undefined ? true : record;
  },
};
const actions = {
  async getIsDone({commit, rootGetters}, types) {
    const userData = rootGetters['auth/userData'];
    const userId = userData?.id;
    if (!userId) return;
    const result = await userService.getUserPopupRecords({userId, types});
    commit('setRecords', result);
    return result;
  },
  async setIsDone({commit, rootGetters}, type) {
    const userData = rootGetters['auth/userData'];
    const userId = userData?.id;
    if (!userId) return;
    commit('setRecords', {[type]: true});
    const result = await userService.upsertUserPopupRecords({userId, type});
    return result;
  },
};
const mutations = {
  setRecords(state, data) {
    state.records = Object.assign(state.records || {}, data);
  },
  clearRecords(state) {
    state.records = null;
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
